import script from "./UserForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserForm.vue?vue&type=script&lang=ts&setup=true"

import "./UserForm.vue?vue&type=style&index=0&id=8b7a534a&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b7a534a"]])

export default __exports__